<template>
  <div>
    <div class="form-group" :class="{ 'd-flex align-items-center': labelSameLine }">
      <label for="base__select" class="mr-2" :class="{ 'font-weight-bold': labelBold }">
        {{ label }}</label
      >

      <b-form-select
        v-model="selected"
        class="base__select"
        :style="styleSelect"
        :options="optionsSelect"
        :value-field="valueField"
        :text-field="textField"
        :disabled="disabled"
        @change="onSelected"
      >
        <slot />
      </b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',

  props: {
    label: {
      type: String,
      default: ''
    },
    labelBold: {
      type: Boolean,
      default: false
    },
    labelSameLine: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [Number, String],
      default: null
    },
    optionsSelect: {
      type: Array,
      default: () => []
    },
    styleSelect: {
      type: String,
      default: ''
    },
    valueField: {
      type: [Number, String],
      default: ''
    },
    textField: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: this.defaultValue
    };
  },

  methods: {
    onSelected(value) {
      this.$emit('onFilterSelected', value);
    },

    setValue(value) {
      this.selected = value;
      this.$emit('onFilterSelected', value);
    }
  }
};
</script>
